import type { QuoteCategory } from "./types";

export const categories: { name: QuoteCategory; emoji: string; description: string }[] = [
  { name: "Sabar & Tawakkal", emoji: "🤲", description: "Kesabaran dan kepasrahan kepada Allah" },
  { name: "Ilmu & Hikmah", emoji: "📖", description: "Keutamaan menuntut ilmu dan kebijaksanaan" },
  { name: "Akhlak", emoji: "🌙", description: "Budi pekerti dan karakter mulia" },
  { name: "Sedekah & Kebaikan", emoji: "🤝", description: "Kemuliaan memberi dan berbuat baik" },
  { name: "Doa & Dzikir", emoji: "🕌", description: "Kekuatan doa dan mengingat Allah" },
  { name: "Ibadah & Ramadhan", emoji: "✨", description: "Keutamaan ibadah puasa dan bulan Ramadhan" },
];
